import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#02462E",
  color: "#FCFCFC",
  fontFamily: "DM Sans, sans-serif",
  fontWeight: 700,
  fontSize: "24px",
  lineHeight: "24px",
  letterSpacing: "-2%",
  textAlign: "left",
  flexWrap: "nowrap",
  textTransform: "none",
  padding: "12px 24px",
  borderRadius: "10px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "707px",
  height: "64px",
  marginBottom: "16px",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    color: "#02462E",
    background: "#FEC700",
    boxShadow: "0px 4px 12px rgba(254, 199, 0, 0.4)",
  },
  "& .arrow": {
    marginLeft: "auto",
    fontSize: "24px",
    lineHeight: "24px",
  },
  animation: "moveInRight 300ms ease-out",

  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    fontSize: "18px",
    lineHeight: "22px",
    padding: "10px 16px",
    flexWrap: "wrap",
    whiteSpace: "normal",
  },
}));

const CustomButton = ({ title, route }) => {
  const navigate = useNavigate();

  return (
    <StyledButton onClick={() => navigate(route)}>
      {title}
      <span className="arrow">→</span>
    </StyledButton>
  );
};

const styles = `
  @keyframes moveInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

export default CustomButton;
